// Геометрия и начертание двадцати мест нейрокарты.
//
// ЧИСТЫЙ модуль: MapCanvas берёт отсюда коллекцию и краски, а укладку слоёв
// делает сам. Вторая копия начертания разъехалась бы с первой при первой же
// правке — так уже расходились палитры карты и пороги скорости судна.
//
// ЧТО ЭТО ТАКОЕ. Гейт 04.09.2026 развалил метрику надвое: на всём тоннаже сеть
// проигрывает памяти «где ловили вчера» втрое (1,93 % против 6,52 % на
// запечатанном окне), а на тоннаже НОВЫХ мест — там, где вчера никого не было, —
// память даёт 0,03 %, сеть 5,58 %. Значит товар это ДВАДЦАТЬ ТОЧЕК вне вчерашней
// окрестности, а заливка под ними — подложка, объясняющая, почему они там.

import type { NnMark } from '../api'

/** Номер места печатается НА карте: двадцатка упорядочена, и без номера все
 *  двадцать читаются как равные — то есть теряется ровно то, чем список
 *  отличается от пятна. */
export function marksCollection(marks: NnMark[]): GeoJSON.FeatureCollection {
  return {
    type: 'FeatureCollection',
    features: marks.map(m => ({
      type: 'Feature' as const,
      properties: {
        rank: m.rank,
        field_rank: m.field_rank,
        ...(m.log_intensity != null ? { log_intensity: m.log_intensity } : {}),
      },
      geometry: { type: 'Point' as const, coordinates: [m.lon, m.lat] },
    })),
  }
}

/** Радиус кружка. Первые места крупнее: порядок читается и без чтения цифр,
 *  на обзорном зуме, где текст ещё не набран. */
/** Цвет кружка места — его же рисует строка легенды. */
export const MARK_COLOR = '#0b1622'

export function markCirclePaint() {
  return {
    'circle-radius': [
      'interpolate', ['linear'], ['zoom'],
      4, ['interpolate', ['linear'], ['get', 'rank'], 1, 7, 20, 4],
      9, ['interpolate', ['linear'], ['get', 'rank'], 1, 14, 20, 9],
    ],
    'circle-color': MARK_COLOR,
    'circle-opacity': 0.85,
    // Обводка БЕЛАЯ и на всех брендах одна: это приём читаемости поверх чужой
    // картинки (растр заливки, подложка карты), а не айдентика.
    'circle-stroke-width': 1.6,
    'circle-stroke-color': '#ffffff',
  }
}

/** Подпись — номер места. Появляется с зума, где кружки перестают слипаться:
 *  двадцать цифр поверх бассейна нечитаемы и только прячут заливку. */
export const MARK_LABEL_MIN_ZOOM = 5

/** Сколько номеров нарисовано картинками — столько мест в двадцатке. */
export const MARK_RANKS = 20

/** id картинки номера. Номер рисуется КАРТИНКОЙ, а не текстом: сервера глифов
 *  у карты кабинета нет, и текстовый слой не рисуется вовсе (прод 01.11.2026). */
export const markRankImageId = (rank: number) => `nn-rank-${rank}`

export function markLabelLayout() {
  return {
    'icon-image': ['concat', 'nn-rank-', ['to-string', ['get', 'rank']]],
    'icon-size': ['interpolate', ['linear'], ['zoom'], 5, 0.75, 9, 1.1],
    'icon-allow-overlap': true,
    'icon-ignore-placement': true,
  }
}
